export enum BankIDDevice {
  This = 'this',
  Other = 'other',
}
